<template>
  <div class="clearfix">
    <!-- text message -->
    <div class="text-link-box" v-if="type=='text'">
      <p v-if="!isAppWebView" class="msg-text" v-html="filterText(content)"></p>
      <p v-if="isAppWebView" class="msg-text" v-html="filterText(content)" @click="openBrowser($event)"></p>
    </div>
    <!-- image message -->
    <div class="img-box" v-if="type=='image'">
      <p class="msg-image">
        <a v-if="!isAppWebView" target="_blank" :href="content.url">
          <lazy-image :src="content.url" :scroll-container="`.chat-message`" />
        </a>
        <lazy-image v-if="isAppWebView" :src="content.url" @click="openBrowser($event)"  :scroll-container="`.chat-message`" />
      </p>
      <p class="msg-text" v-if="content.text" v-html="filterText(content)"></p>
      <p class="msg-text" v-if="content.text && isAppWebView" v-html="filterText(content)" @click="openBrowser($event)"></p>
    </div>
    <!-- file message -->
    <div class="msg-file" v-if="type=='file'">
      <a target="_blank"
         :title="content.text"
         @click="handleDownloadLink($event)" :href="content.url">
        <i class="fas fa-file-download"></i>
      </a>
      <p class="msg-text" v-if="content.text" v-html="filterText(content)"></p>
    </div>
    <!-- audio message -->
    <p class="msg-audio" v-if="type=='audio'">
      <audio-player :src="formatURL(content.url)" />
    </p>
    <!-- voice message -->
    <div class="msg-voice-wechat" v-if="type=='voice'">
      <audio-player :src="formatURL(content.url)" />
    </div>
    <!-- video message -->
    <p class="msg-video" v-if="type=='video'">
      <video controls width="100%">
        <source :src="content.url">
      </video>
    </p>
    <!-- sticker message -->
    <p class="msg-image" v-if="type=='sticker'">
      <lazy-image :src="content.url" :scroll-container="`.chat-message`" />
    </p>
    <!-- welcome template message -->
    <small class="template-note" v-if="isTemplateMsg">
      <span v-if="isWelcomeMsg">
        *與此用戶上一次對話已經超過24小時，上一條消息可能未能發送，此爲自動發送消息，需要等候用戶回覆才可以繼續。<br>
      </span>
      <span>*此消息模板消息</span>
    </small>
    <!-- not support message -->
    <p class="msg-not-support" v-if="isNotSupportMessage">
      未支持的消息類型，無法顯示 <br>
      The message type is not supported and cannot be displayed
    </p>
  </div>
</template>
<script>
import audioPlayer from "./audio-player.vue"
import JSbridge from "../Services/JSbridge";
import LazyImage from "../components/lazy-img";
import {isBizChatApp} from "../utils/detect";

export default {
  components: {
    audioPlayer,
    LazyImage,
  },

  props: {
    content: {
      default: {
        text: "",
        url: ""
      }
    },
    type: {
      default: "text"
    }
  },
  data(){
    return{
      is_playing: false,
      voiceLoaded: false
    }
  },

  computed: {
    isWelcomeMsg() {
      const template_id = this.content.template_id || '';
      return template_id.includes('welcome');
    },
    isTemplateMsg() {
      return this.content.chat_msg_type === 'TEMPLATE_MSG';
    },
    isAppWebView() {
      return isBizChatApp();
    },
    isNotSupportMessage() {
      return !(['text', 'audio', 'video', 'voice', 'file', 'sticker', 'image'].includes(this.type));
    }
  },

  methods: {
    openBrowser(e) {
      e.preventDefault();
      const target = e.target;
      if (target && target instanceof HTMLImageElement) {
        JSbridge.browserOpen(target.src);
      }
      if (target && target instanceof HTMLAnchorElement) {
        JSbridge.browserOpen(target.href);
      }
    },

    handleDownloadLink(e) {
      if (isBizChatApp()) {
        e.preventDefault();
        const target = e.currentTarget;
        console.log(target);
        JSbridge.browserOpen(target.href);
      }
    },

    filterText(content = {
      text: ""
    }) {
      let msg = "";
      // URL matching regex
      let urlReg = /((ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;

      const text = content?.text || "";

      if (text) {
        // First handle URLs
        const links = text.match(urlReg) || [];
        msg = links.reduce((last, link, i) => {
          return last.replace(link, `$link-${i}`);
        }, text);

        // Handle WhatsApp markdown formatting
        // Bold: *text*
        msg = msg.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

        // Italic: _text_
        msg = msg.replace(/_(.*?)_/g, '<em>$1</em>');

        // Strikethrough: ~text~
        msg = msg.replace(/~(.*?)~/g, '<del>$1</del>');

        // Monospace: ```text```
        msg = msg.replace(/```(.*?)```/g, '<code>$1</code>');

        msg = links.reduce((last, link, i) => {
          return last.replace(`$link-${i}`, this.replacer(link));
        }, msg)
      }

      return msg.replace(/\n/gi, "<br/>");
    },

    replacer(matchLink) {
      const maxLength = 35;
      let displayText = matchLink;

      // 格式化 URL
      const formattedUrl = this.formatURL(matchLink);

      if (matchLink.length > maxLength) {
        displayText = matchLink.substring(0, maxLength - 3) + '...';
      }

      return `<a class="msg-link" title="${formattedUrl}" target="_blank" href="${formattedUrl}">${displayText}</a>`;
    },

    formatURL(url) {
      if (!url) return '';

      // 如果已经有协议头，直接返回
      if (url.match(/^(https?:)\/\//)) {
        return url;
      }

      // 获取当前页面的协议
      const currentScheme = window.location.protocol;

      // 如果 URL 以 // 开头，添加当前协议
      if (url.startsWith('//')) {
        return `${currentScheme}${url}`;
      }

      // 如果 URL 以 / 开头，使用完整的当前协议和主机名
      if (url.startsWith('/')) {
        return `${currentScheme}//${window.location.host}${url}`;
      }

      // 其他情况，默认添加 https://
      return `https://${url}`;
    }
  },
};
</script>
<style>
.template-note {
  opacity: 0.8;
  font-size: 12px;
  font-style: italic;
}

.msg-text code {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

.msg-text del {
  color: #666;
}
</style>

